import { Table } from "@redriver/cinnamon";
import React, { Fragment } from "react";
import ViewRequest from "features/Companies/Customers/Change Requests/Actions Menu/ViewRequest";
import DeleteRequest from "features/Companies/Customers/Change Requests/Actions Menu/DeleteRequest";
import { ClientInfoReviewState } from "features/../../../shared/constants/enums/ClientInfoReviewState";
import ViewOriginalRequest from "features/Companies/Customers/Change Requests/Actions Menu/ViewOriginalRequest";

const ActionsMenu = ({ requestId, clientId, reviewState, onSubmitted }) => {
  const isReviewed = [
    ClientInfoReviewState.Approved,
    ClientInfoReviewState.Rejected,
  ].includes(reviewState);

  const isPending = reviewState === ClientInfoReviewState.Pending;

  // Nothing to show for other states (optional)
  if (!isReviewed && !isPending) return null;

  return (
    <Fragment>
      <Table.Menu>
        {isReviewed ? (
          <ViewOriginalRequest
            clientId={clientId}
            requestId={requestId}
            onSubmitted={onSubmitted}
          />
        ) : (
          <Fragment>
            <ViewRequest requestId={requestId} onSubmitted={onSubmitted} />
            <DeleteRequest requestId={requestId} onSubmitted={onSubmitted} />
          </Fragment>
        )}
      </Table.Menu>
    </Fragment>
  );
};

export default ActionsMenu;
